import { Component, type ErrorInfo, type ReactNode } from "react";
import { Aviso } from "./Basicos";
import { Botao } from "./Botao";

/**
 * Tela que quebrou (erro de renderizacao) nao vira pagina em branco: mostra o aviso, o botao de recarregar e o codigo
 * do erro pro suporte. O design system nao sabe onde o erro e registrado: o app passa `aoErro`, que devolve o codigo.
 */
export class LimiteDeErro extends Component<{ children: ReactNode; aoErro?: (erro: unknown, pilhaDeComponentes?: string) => string | undefined }, { quebrou: boolean; codigo?: string }> {
  state: { quebrou: boolean; codigo?: string } = { quebrou: false };
  static getDerivedStateFromError() {
    return { quebrou: true };
  }
  componentDidCatch(erro: unknown, info: ErrorInfo) {
    this.setState({ codigo: this.props.aoErro?.(erro, info.componentStack ?? undefined) });
  }
  render() {
    if (!this.state.quebrou) return this.props.children;
    return <TelaQuebrada codigo={this.state.codigo} />;
  }
}

/** O que aparece no lugar da tela que quebrou. */
export function TelaQuebrada({ codigo }: { codigo?: string }) {
  return (
    <div className="mtc-tela-quebrada" role="alert">
      <Aviso tipo="erro">
        Algo deu errado nesta tela. Recarregue a página; se continuar, fale com o suporte{codigo ? <> e mande o código <strong className="mtc-mono">{codigo}</strong></> : null}.
      </Aviso>
      <Botao onClick={() => window.location.reload()}>Recarregar a página</Botao>
    </div>
  );
}
